import React from "react";
import { GlobalStyles } from "../../constants/styles";

const BrandName = ({
    className = "",
    colors = {},
    size = "inherit",
    sizes = {},
    style = {},
    sportsStyle = {},
}) => {
    const brandColors = {
        angeon: GlobalStyles.colors.brandWhite,
        x: GlobalStyles.colors.brandBlue,
        sports: GlobalStyles.colors.brandOrange,
        ...colors,
    };

    return (
        <span className={`kbola-brand-name ${className}`.trim()} style={{fontSize: size, ...style}}>
            <span style={{color: brandColors.angeon, fontSize: sizes.angeon || size}}>Angeon</span>
            <span style={{color: brandColors.x, fontSize: sizes.x || size}}>X</span>
            <span style={{color: brandColors.sports, fontSize: sizes.sports || size, ...sportsStyle}}>Sports</span>
        </span>
    );
};

export default BrandName;
